import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      variant: 'flex.column.start.between',
      height: '100%',
      width: '100%',
      '[data-comp="AddToCart"], [data-comp="SeeDetails"]': {
        opacity: 1,
        transition: 'all 0.2s ease-in-out',
        ':focus': {
          opacity: 1,
        },
      },
      ':hover': {
        '[data-comp="AddToCart"], [data-comp="SeeDetails"]': {
          opacity: 1,
        },
      },
    };

    this.atc = {
      mt: [6, 8],
      width: ['100%', 'unset'],
    };
  })()
);
